import { FeatureFlags } from './features'

const LOCAL: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: true,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

const DEV: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: true,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

const QA: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: true,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

/**
 * Nova runs the same codebase as the mainline, so flags are how a mainline feature is turned off
 * there without affecting dev or qa.
 *
 * The CRT flags are off: Nova does not use that module. The credit and assortment flags stay on,
 * since it uses both.
 */
const DEV_NOVA: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: false,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

const QA_NOVA: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: false,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

/** Pre-prod is Nova but, unlike the other Nova sets, keeps the CRT flags it had on. */
const PP: FeatureFlags = {
  replaceMaterialsInAssortment: true,
  replaceMaterialsInLaunches: true,
  permissionOverrides: false,
  viewPnlGraphs: false,
  clrEmailNotifications: true,
  clrAutoPrepareDigest: true,
  massClr: true,
  clrInbox: true,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

const PROD: FeatureFlags = {
  replaceMaterialsInAssortment: false,
  replaceMaterialsInLaunches: false,
  permissionOverrides: false,
  viewPnlGraphs: false,
  clrEmailNotifications: false,
  clrAutoPrepareDigest: false,
  massClr: false,
  clrInbox: false,
  initiatives: false,
  blockedOrderSapRemovalConfirms: false,
}

export const FEATURE_FLAGS_ENV = {
  LOCAL,
  DEV,
  DEV_NOVA,
  QA,
  QA_NOVA,
  PP,
  PROD,
}
